import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'

const ifNotAuthenticated = (to, from, next) => {
    if(!store.getters.userIsLoggedIn) { next(); }
    else { next({ name: 'home' }); }
};

const ifAuthenticated = (to, from, next) => {
    if(store.getters.userIsLoggedIn) { next(); }
    else { next({ name: 'login' }); }
};

const routes = [
    {
        path     : '/',
        // redirect : '/dashboard',
        name     : 'home',
        component: () => import(/* webpackChunkName: "home-index" */ '../components/pages/home/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Εφαρμογή θεωρητικής εκπαίδευσης - Test K.O.K.',
        },
        props: true,
    },

    {
        path     : '/e/:reference_to_title/300:exam_type_id/:chapter_title?/400:chapter_id?',
        name     : 'exam',
        component: () => import(/* webpackChunkName: "exam-index" */ '../components/pages/exam/Index'),
        beforeEnter: (to, from, next) => {
            if(to.params.exam_type_id > 0) { next(); }
            else { next({ name: 'home' }); }
        },
        meta : {
            label : 'Test K.O.K. - Σήματα Οδήγησης',
            title_changed: false,
        },
        props: true,
    },

    {
        path     : '/r/:id',
        name     : 'exam_result',
        component: () => import(/* webpackChunkName: "exam-result" */ '../components/pages/exam/Result'),
        beforeEnter: (to, from, next) => {
            if(!_.isEmpty(to.params.id)) { next(); }
            else { next({ name: 'home' }); }
        },
        meta : {
            label : 'Test K.O.K. - Σήματα Οδήγησης αποτελέσματα',
        },
        props: true,
    },

    {
        path     : '/e/:reference_to_title?/300:exam_type_id/c',
        name     : 'exam_chapters',
        component: () => import(/* webpackChunkName: "exam-chapters" */ '../components/pages/exam/Chapters'),
        beforeEnter: (to, from, next) => {
            if(to.params.exam_type_id > 0) { next(); return; }

            next({ name: 'home' });
        },
        meta : {
            label : 'Test K.O.K. - Σήματα Οδήγησης Κεφάλαιο',
            title_changed: false,
        },
        props: true,
    },

    {
        path     : '/kok-episima-vivlia-theorias-simaton-tou-upourgiou',
        // redirect : '/dashboard',
        name     : 'books',
        component: () => import(/* webpackChunkName: "books" */ '../components/pages/book/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Επίσημα βιβλία του Κώδικας Οδικής Κυκλοφορίας',
        },
        props: true,
    },

    {
        path     : '/pinakides-simansis-tou-kok/:type_id?',
        // redirect : '/dashboard',
        name     : 'road_signs',
        component: () => import(/* webpackChunkName: "road-signs" */ '../components/pages/roadsign/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Πινακίδες σήμανσης του Κ.Ο.Κ.',
        },
        props: true,
    },

    {
        path     : '/pinakides-simansis-tou-kok/:type_id/:title?',
        // redirect : '/dashboard',
        name     : 'road_signs_sign',
        meta : {
            label : 'Πινακίδες σήμανσης του Κ.Ο.Κ.',
        },
        props: true,
    },

    {
        path     : '/privacy-policy',
        name     : 'privacy_policy',
        // component: () => import(/* webpackChunkName: "home-index" */ '../components/pages/home/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Privacy policy',
        },
        props: true,
    },

    {
        path     : '/terms-of-use',
        name     : 'terms_of_use',
        // component: () => import(/* webpackChunkName: "home-index" */ '../components/pages/home/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Terms Of Use',
        },
        props: true,
    },

    {
        path     : '/epikoinwnia',
        name     : 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '../components/pages/contact/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Επικοινωνία',
        },
        props: true,
    },

    {
        path     : '/ta-nea-mas',
        name     : 'news',
        component: () => import(/* webpackChunkName: "news" */ '../components/pages/news/Index'),
        meta : { label : 'Τα νέα μας' },
        props: true,
    },

    {
        path     : '/about-us',
        name     : 'about_us',
        // component: () => import(/* webpackChunkName: "home-index" */ '../components/pages/home/Index'),
        // beforeEnter: ifAuthenticated,
        meta : {
            label : 'Σχετικά',
        },
        props: true,
    },

    {
        path     : '/test-kok-ypourgeiou-gia-ta-simata-odigisis',
        name     : 'test_kok_ypourgeiou_gia_simata_odigisis',
        meta : { label : 'Test K.O.K. Υπουργείου για τα σήματα οδήγησης' },
        props: true,
    },

    {
        path     : '/shmata-odhghshs-test-upourgeiou',
        name     : 'shmata_odhghshs_test_upourgeiou',
        meta : { label : 'Σήματα Οδήγησης τεστ υπουργείου' },
        props: true,
    },

    {
        path     : '/simata-odigisis',
        name     : 'simata_odigisis',
        meta : { label : 'Σήματα οδήγησης' },
        props: true,
    },

    {
        path     : '/test-odigisis',
        name     : 'test_odigisis',
        meta : { label : 'Τεστ οδήγησης' },
        props: true,
    },

    {
        path     : '/sxoles-odigon',
        name     : 'sxoles_odigon',
        meta : { label : 'Σχολές Οδηγών' },
        props: true,
    },

    {
        path     : '/test-online',
        name     : 'test_online',
        meta : { label : 'Test Online K.O.K. Υπουργείου για τα σήματα οδήγησης' },
        props: true,
    },

    {
        path     : '/test-drive-simata-odigisis-test-kok',
        name     : 'test_drive_simata_odigisis_test_kok',
        meta : { label : 'Test Drive σήματα Οδήγησης Τεστ Κοκ' },
        props: true,
    },

    {
        path     : '/test-drive',
        name     : 'test_drive',
        meta : { label : 'Test Drive - σήματα Οδήγησης' },
        props: true,
    },

    {
        path     : '/eisai-mathitis',
        name     : 'eisai_mathitis',
        meta : { label : 'Είσαι μαθητής' },
        props: true,
    },

    {
        path     : '/proswrinh-adeia-odhghshs',
        name     : 'proswrinh_adeia_odhghshs',
        meta : { label : 'Προσωρινή Άδεια Οδήγησης Online' },
        props: true,
    },

    {
        path     : '/eidikh-adeia-taxi',
        name     : 'eidikh_adeia_taxi',
        meta : { label : 'Ειδική Άδεια Ταξί' },
        props: true,
    },

    {
        path     : '/apwleia-h-kloph-fthora-diplwmatos',
        name     : 'apwleia_h_kloph_fthora_diplwmatos',
        meta : { label : 'Απώλεια ή Κλοπή-Φθορά διπλώματος' },
        props: true,
    },

    {
        path     : '/ananewsh-diplwmatos-odhghshs',
        name     : 'ananewsh_diplwmatos_odhghshs',
        meta : { label : 'Ανανέωση διπλώματος οδήγησης' },
        props: true,
    },

    {
        path     : '/metabibaseis',
        name     : 'metabibaseis',
        meta : { label : 'Μεταβιβάσεις' },
        props: true,
    },

    {
        path     : '/karta-pshfiakoy-taxografoy',
        name     : 'karta_pshfiakoy_taxografoy',
        meta : { label : 'Κάρτα ψηφιακού ταχογράφου' },
        props: true,
    },

    {
        path     : '/sustima-elegxou-symperiforas-odhgwn-seso',
        name     : 'odigisi_mixanis_me_diploma_autokinitou',
        meta : { label : 'Σύστημα Ελέγχου Συμπεριφοράς Οδηγών (Σ.Ε.Σ.Ο.)' },
        props: true,
    },

    {
        path     : '/odigisi-mixanis-me-diploma-autokinitou',
        name     : 'seso_sustima',
        meta : { label : 'Οδήγηση μηχανής με δίπλωμα αυτοκινήτου' },
        props: true,
    },

    {
        path     : '/diplwmata-odigisis',
        name     : 'diplwmata_odigisis',
        meta : { label : 'Διπλώματα Οδήγησης' },
        props: true,
    },

    {
        path     : '/diplwmata-odigisis/motosikleta-mixani',
        name     : 'diplwmata_odigisis_motosikleta',
        meta : { label : 'Διπλώματα Οδήγησης - Μοτοσυκλέτας / Μηχανής' },
        props: true,
    },

    {
        path     : '/diplwmata-odigisis/autokinito',
        name     : 'diplwmata_odigisis_autokinito',
        meta : { label : 'Διπλώματα Οδήγησης - Αυτοκίνητο' },
        props: true,
    },

    {
        path     : '/diplwmata-odigisis/fortigo',
        name     : 'diplwmata_odigisis_fortigo',
        meta : { label : 'Διπλώματα Οδήγησης - Φορτηγό' },
        props: true,
    },

    {
        path     : '/diplwmata-odigisis/lewforeio',
        name     : 'diplwmata_odigisis_lewforeio',
        meta : { label : 'Διπλώματα Οδήγησης - Λεωφορείο' },
        props: true,
    },

    {
        path     : '/diplwmata-odigisis/ntalika',
        name     : 'diplwmata_odigisis_ntalika',
        meta : { label : 'Διπλώματα Οδήγησης - Νταλίκα' },
        props: true,
    },

    {
        path     : '/premium',
        name     : 'premium',
        meta : { label : 'Premium' },
        props: true,
    },

    {
        path     : '/donate',
        name     : 'donate',
        component: () => import(/* webpackChunkName: "donate" */ '../components/pages/donate/Index'),
        meta : { label : 'Donate' },
        props: true,
    },

    {
        path     : '/panel/students',
        name     : 'panel_students',
        component: () => import(/* webpackChunkName: "school-students" */ '../components/pages/school/Students'),
        beforeEnter: ifAuthenticated,
        meta : { label : 'Students' },
        props: true,
    },

    {
        path     : '/social/*',
        name     : 'social',
        redirect : { path : '/', query : {} },
        meta : {
            label : 'Social',
        },
        props: true,
    },

    {
        path     : '/school/student/token/*',
        name     : 'school_student_token',
        redirect : { path : '/', query : {} },
        meta : {
            label : 'School Student',
        },
        props: true,
    },

    // account profile
    {
        path     : '/account',
        name     : 'account',
        redirect : '/account/personal-details',
        component: () => import(/* webpackChunkName: "account-view" */ '../components/pages/account/Account'),
        beforeEnter: ifAuthenticated,
        meta : {
            label : 'Account',
        },
        props: true,
        children : [
            {
                path     : 'personal-details',
                name     : 'account_personal_details',
                component: () => import(/* webpackChunkName: "account-personal-details" */ '../components/pages/account/Personal'),
                meta : {
                    label : 'Personal details',
                }
            },

            {
                path     : 'manage',
                name     : 'account_password_manage',
                component: () => import(/* webpackChunkName: "account-password-manage" */ '../components/pages/account/PasswordManage'),
                meta : {
                    label : 'Password manage',
                }
            },
        ]
    },

    {
        path     : '/account/exams',
        name     : 'account_exams',
        component: () => import(/* webpackChunkName: "account-exams" */ '../components/pages/account/exam/Exams'),
        beforeEnter: ifAuthenticated,
        meta : {
            label : 'My Exams',
        },
        props: true,
    },

    {
        path     : '/account/exams/stats',
        name     : 'account_exams_stats',
        component: () => import(/* webpackChunkName: "account-exams-stats" */ '../components/pages/account/exam/Stats'),
        beforeEnter: ifAuthenticated,
        meta : {
            label : 'My Stats',
        },
        props: true,
    },

    {
        path     : '/account/userlists',
        name     : 'account_userlists',
        component: () => import(/* webpackChunkName: "account-userlists" */ '../components/pages/account/userlist/UserLists'),
        beforeEnter: ifAuthenticated,
        meta : { label : 'UserLists' },
        props: true,
    },

    {
        path     : '/account/userlist/:uid',
        name     : 'account_userlist',
        component: () => import(/* webpackChunkName: "account-userlist" */ '../components/pages/account/userlist/UserList'),
        beforeEnter: ifAuthenticated,
        meta : { label : 'UserList' },
        props: true,
    },

    // account
    { path: '/login', name:'login', component: () => import(/* webpackChunkName: "account-login" */ '../components/pages/account/Login'), beforeEnter: ifNotAuthenticated, meta : { label : 'Σύνδεση μαθητή' } },
    { path: '/register', name:'register', component: () => import(/* webpackChunkName: "account-register" */ '../components/pages/account/Register'), beforeEnter: ifNotAuthenticated, meta : { label : 'Εγγραφή μαθητή' } },
    { path: '/password/reset*', name:'password_reset', component: () => import(/* webpackChunkName: "account-password-reset" */ '../components/pages/account/PasswordReset'), beforeEnter: ifNotAuthenticated, meta : { label : 'Password Reset' } },

    // errors
    //{ path: '*', name: '404', component: () => import(/* webpackChunkName: "page-error-404" */  '../components/pages/errors/404'), meta : { label : '404' }, props: true },
    { path: '/:slug?', name: 'page', component: () => import(/* webpackChunkName: "page" */  '../components/pages/page/Index'), meta : { label : 'Page' }, props: true },
];

Vue.use(VueRouter);

const router = new VueRouter({
    mode : 'history',
    linkActiveClass: 'open active',
    scrollBehavior : () => ({ y: 0 }),
    routes,
});

router.beforeEach((to, from, next) => {
    let title_changed = _.get(to, 'meta.title_changed', true);
    if(title_changed) {
        let title = _.get(to, 'meta.label', '');
        if(!_.isEmpty(title)) { document.title = title + ' | ' + store.getters.global.name; }
        else { document.title = store.getters.global.name; }
    }
    next();
});

export default router;
